export function select($element) {
    return {
        type: 'SELECT_ELEMENT',
        $element,
    }
}

export function multiSelect($element) {
    return {
        type: 'MULTI_SELECT_ELEMENT',
        $element,
    }
}

export function multiDeselect($element) {
    return {
        type: 'MULTI_DESELECT_ELEMENT',
        $element,
    }
}

export function updateCtrlPressed(pressed) {
    return {
        type: 'UPDATE_CTRL_PRESSED',
        pressed,
    }
}

export function updateShiftPressed(pressed) {
    return {
        type: 'UPDATE_SHIFT_PRESSED',
        pressed,
    }
}

export function updateElementAttribute(key, value) {
    return {
        type: 'UPDATE_ELEMENT_ATTRIBUTE',
        key,
        value,
    }
}

export function deselect() {
    return {
        type: 'DESELECT_ELEMENT',
    }
}

export function updateZoom(zoom) {
    return {
        type: 'UPDATE_ZOOM',
        zoom,
    }
}

export function setMinZoom(minZoom) {
    return {
        type: 'SET_MIN_ZOOM',
        minZoom,
    }
}

export function setMaxZoom(maxZoom) {
    return {
        type: 'SET_MAX_ZOOM',
        maxZoom,
    }
}

export function setZoomAdjusted(zoomAdjusted) {
    return {
        type: 'SET_ZOOM_ADJUSTED',
        zoomAdjusted,
    }
}

export function showLayoutGuideBar(isLayoutGuideToggled) {
    return {
        type: 'SHOW_LAYOUT_GUIDE_BAR',
        isLayoutGuideToggled
    }
}
export function showSafetyZone(isSafetyZoneToggled) {
    return {
        type: 'SHOW_SAFETY_ZONE',
        isSafetyZoneToggled
    }
}

export function showLayoutGuideProps(cfg) {
    return {
        type: 'SHOW_LAYOUT_GUIDE_PROPS',
        layoutGuide: cfg.guide,
        layoutGuidePageMargin: cfg.pageMargin,
        layoutGuideColumnMargin: cfg.columnMargin
    }
}

export function setLayoutGuide(layoutGuide) {
    return {
        type: 'SET_LAYOUT_GUIDE',
        layoutGuide,
    }
}

export function setLayoutGuidePageMargin(layoutGuidePageMargin) {
    return {
        type: 'SET_LAYOUT_GUIDE_PAGE_MARGIN',
        layoutGuidePageMargin,
    }
}

export function setLayoutGuideColumnMargin(layoutGuideColumnMargin) {
    return {
        type: 'SET_LAYOUT_GUIDE_COLUMN_MARGIN',
        layoutGuideColumnMargin,
    }
}

export function setIsNewDesign(isNewDesign) {
    return {
        type: 'SET_IS_NEW_DESIGN',
        isNewDesign,
    }
}

export function setIsItemLibraryModal(isItemLibraryModal) {
    return {
        type: 'SET_IS_ITEM_LIBRARY_MODAL',
        isItemLibraryModal,
    }
}

export function setItemLibraryDefaultView(itemLibraryDefaultView) {
    return {
        type: 'SET_ITEM_LIBRARY_DEFAULT_VIEW',
        itemLibraryDefaultView
    }
}

export function setIsDataLibraryModal(isDataLibraryModal) {
    return {
        type: 'SET_IS_DATA_LIBRARY_MODAL',
        isDataLibraryModal,
    }
}

export function setIsMOEditModal(isMOEditModal) {
    return {
        type: 'SET_IS_MO_EDIT_MODAL',
        isMOEditModal,
    }
}

export function setMOEditMode(MOEditMode) {
    return {
        type: 'SET_MO_EDIT_MODE',
        MOEditMode,
    }
}

export function setMoSelectedItemIdx(moSelectedItemIdx) {
    return {
        type: 'SET_MO_SELECTED_ITEM_IDX',
        moSelectedItemIdx
    }
}

export function setMoLastSortDate(moLastSortDate) {
    return {
        type: 'SET_MO_LAST_SORT_DATE',
        moLastSortDate
    }
}

export function setIsPosConnectModal(isPosConnectModal) {
    return {
        type: 'SET_IS_POS_CONNECT_MODAL',
        isPosConnectModal,
    }
}

export function setIsMMGTourModal(isMMGTourModal) {
    return {
        type: 'SET_IS_MMG_TOUR_MODAL',
        isMMGTourModal,
    }
}

export function setIsPOSTourModal(isPOSTourModal) {
    return {
        type: 'SET_IS_POS_TOUR_MODAL',
        isPOSTourModal,
    }
}

export function goToView(view) {
    return {
        type: 'GO_TO_VIEW',
        view,
    }
}

export function goToSubview(subview) {
    return {
        type: 'GO_TO_SUBVIEW',
        subview,
    }
}

export function setIsLeftMenuVisible(isLeftMenuVisible) {
    return {type: 'SET_IS_LEFT_MENU_VISIBLE', isLeftMenuVisible};
}

export function setDesign(design) { return { type: 'SET_DESIGN', design } }

export function markAsModified() { return { type: 'MARK_AS_MODIFIED' } }

export function setLastUpdate(stamp) { return { type: 'SET_LAST_UPDATE', stamp } }
export function setLastSaved(stamp) { return { type: 'SET_LAST_SAVED', stamp } }

export function setDesignName(name) {
    return { type: 'SET_DESIGN_NAME', name }
}

export function setDesignFolders(folders) {
    return { type: 'SET_DESIGN_FOLDERS', folders }
}

export function setDesignSize(size) {
    return { type: 'SET_DESIGN_SIZE', size }
}

export function setIsTextHighlight($element, range, format) {
    return {
        type: 'SET_IS_TEXT_HIGHLIGHT',
        $element,
        range,
        format,
    }
}

export function disableTextHighlight() {
    return { type: 'DISABLE_TEXT_HIGHLIGHT' }
}

export function setDesignId(id) {
    return { type: 'SET_DESIGN_ID', id }
}

export function setIsTemplateLink(isTemplateLink) {
    return { type: 'SET_IS_TEMPLATE_LINK', isTemplateLink }
}

export function setLocationId(id) {
    return { type: 'SET_LOCATION_ID', id }
}

export function setBrand(brand) {
    return { type: 'SET_BRAND', brand }
}

export function setDesignStatus(status) {
    return { type: 'SET_DESIGN_STATUS', status }
}

export function setDesigner(designer) {
    return { type: 'SET_DESIGNER', designer }
}

export function updateDesignColors(colors) {
    return { type: 'UPDATE_DESIGN_COLORS', colors }
}

export function updateDesignFonts(fonts) {
    return { type: 'UPDATE_DESIGN_FONTS', fonts }
}

export function showPromos() {
    return { type: 'SHOW_PROMOS' }
}

export function setPromoDesigns(designs, isLoading = false) {
    return { type: 'SET_PROMO_DESIGNS', designs, isLoading }
}

export function showCollections(show) {
    return { type: 'SHOW_COLLECTIONS', show }
}

export function setPublicPromoDesigns(designs, isLoading = false) {
    return { type: 'SET_PUBLIC_PROMO_DESIGNS', designs, isLoading }
}

export function setTemplateGroups(groups, isLoading = false) {
    return { type: 'SET_TEMPLATE_GROUPS', groups, isLoading }
}

export function setTemplateFamilies(families, isLoading = false) {
    return { type: 'SET_TEMPLATE_FAMILIES', families, isLoading }
}

export function setTemplateView(view) {
    return { type: 'SET_TEMPLATE_VIEW', view }
}

export function setSelectedFamily(family) {
    return { type: 'SET_SELECTED_FAMILY', family }
}

export function setSelectedCollection(collection) {
    return { type: 'SET_SELECTED_COLLECTION', collection }
}

export function setSelectedCategory(category) {
    return { type: 'SET_SELECTED_CATEGORY', category }
}

export function setPromoLoading(isLoading) {
    return { type: 'SET_PROMO_LOADING', isLoading }
}

export function hidePromos() {
    return { type: 'HIDE_PROMOS' }
}

export function setIsTemplate(isTemplate) {
    return { type: 'SET_IS_TEMPLATE', isTemplate }
}

export function setRulerVisibility(isVisible) {
    return { type: 'SET_RULER_VISIBILITY', isVisible }
}

export function setHistoryNext(has) {
    return { type: 'SET_HISTORY_NEXT', has }
}

export function setHistoryPrev(has) {
    return { type: 'SET_HISTORY_PREV', has }
}

export function flipVertically() {
    return { type: 'FLIP_VERTICALLY' }
}

export function flipHorizontally() {
    return { type: 'FLIP_HORIZONTALLY' }
}

export function setPreserveRatio(preserve) {
    return { type: 'SET_PRESERVE_RATIO', preserve }
}

export function setImportWebsiteModal(modal) {
    return { type: 'SET_IMPORT_WEBSITE_MODAL', modal }
}

export function setVersionPreview(isVersionPreview, revision) {
    return { type: 'SET_VERSION_PREVIEW', isVersionPreview, revision }
}

export function setBucketCount(counts) {
    return { type: 'SET_BUCKET_COUNT', counts }
}

export function showAuthOverlay() {
    return { type: 'SHOW_AUTH_OVERLAY' }
}

export function hideAuthOverlay() {
    return { type: 'HIDE_AUTH_OVERLAY' }
}

export function showConfigureTemplateModal() {
    return { type: 'SHOW_CONFIGURE_TEMPLATE_MODAL' }
}

export function hideConfigureTemplateModal() {
    return { type: 'HIDE_CONFIGURE_TEMPLATE_MODAL' }
}

export function showMoveCopyTemplateModal() {
    return { type: 'SHOW_MOVE_COPY_TEMPLATE_MODAL' }
}

export function hideMoveCopyTemplateModal() {
    return { type: 'HIDE_MOVE_COPY_TEMPLATE_MODAL' }
}

export function showSharingModal() {
    return { type: 'SHOW_SHARING_MODAL' }
}

export function hideSharingModal() {
    return { type: 'HIDE_SHARING_MODAL' }
}

export function showFixImageModal(path) {
    return { type: 'SHOW_FIX_IMAGE_MODAL', path }
}

export function hideFixImageModal() {
    return { type: 'HIDE_FIX_IMAGE_MODAL' }
}

export function showConfigureIllustrationModal() {
    return { type: 'SHOW_CONFIGURE_ILLUSTRATION_MODAL' }
}

export function hideConfigureIllustrationModal() {
    return { type: 'HIDE_CONFIGURE_ILLUSTRATION_MODAL' }
}

export function showConfigureFreeImageModal() {
    return { type: 'SHOW_CONFIGURE_FREE_IMAGE_MODAL' }
}

export function hideConfigureFreeImageModal() {
    return { type: 'HIDE_CONFIGURE_FREE_IMAGE_MODAL' }
}

export function showMenuContentModal(items) {
    return { type: 'SHOW_MENU_CONTENT_MODAL', items }
}

export function hideMenuContentModal() {
    return { type: 'HIDE_MENU_CONTENT_MODAL' }
}

export function showOrganizeUploadsModal() {
    return { type: 'SHOW_ORGANIZE_UPLOADS_MODAL' }
}

export function hideOrganizeUploadsModal() {
    return { type: 'HIDE_ORGANIZE_UPLOADS_MODAL' }
}

export function setMenuObjectItems(menuObjectItems) {
    return { type: 'SET_MENU_OBJECT_ITEMS', menuObjectItems }
}

export function setIsMenuObjectCopied(isMenuObjectCopied) {
    return { type: 'SET_IS_MENU_OBJECT_COPIED', isMenuObjectCopied }
}

export function setMenuObjectStyles(menuObjectStyles) {
    return { type: 'SET_MENU_OBJECT_STYLES', menuObjectStyles }
}

export function setMenuObjectDots(menuObjectDots) {
    return { type: 'SET_MENU_OBJECT_DOTS', menuObjectDots }
}

export function setMenuObjectLayout(menuObjectLayout) {
    return { type: 'SET_MENU_OBJECT_LAYOUT', menuObjectLayout }
}

export function setIconLayout(iconLayout) {
    return { type: 'SET_ICON_LAYOUT', iconLayout }
}

export function setIconsInDescription(iconsInDescription) {
    return { type: 'SET_ICONS_IN_DESCRIPTION', iconsInDescription }
}

export function setIconPosition(iconPosition) {
    return { type: 'SET_ICON_POSITION', iconPosition }
}

export function setShowMenuTag(showMenuTag) {
    return { type: 'SET_SHOW_MENU_TAG', showMenuTag }
}

export function setShowModifiers(showModifiers) {
    return { type: 'SET_SHOW_MODIFIERS', showModifiers }
}

export function setModifierLayout(modifierLayout) {
    return { type: 'SET_MODIFIER_LAYOUT', modifierLayout }
}

export function setModifierDivider(modifierDivider) {
    return { type: 'SET_MODIFIER_DIVIDER', modifierDivider}
}

export function setHidePrices(hidePrices) {
    return { type: 'SET_HIDE_PRICES', hidePrices}
}

export function setHideTrailingZeroes(hideTrailingZeroes) {
    return { type: 'SET_HIDE_TRAILING_ZEROES', hideTrailingZeroes }
}

export function setInlineExtras(inlineExtras) {
    return { type: 'SET_INLINE_EXTRAS', inlineExtras}
}

export function setMenuTagLayout(menuTagLayout) {
    return { type: 'SET_MENU_TAG_LAYOUT', menuTagLayout}
}

export function setPriceDivider(priceDivider) {
    return { type: 'SET_PRICE_DIVIDER', priceDivider}
}

export function setPriceBorder(priceBorder) {
    return { type: 'SET_PRICE_DIVIDER', priceBorder}
}

export function login(member) {
    return { type: 'LOGIN', member }
}

export function setWithBleeds(bleeds) {
    return { type: 'DOWNLOAD_WITH_BLEEDS', bleeds }
}

export function setAuthOverlayView(view) {
    return { type: 'SET_AUTH_OVERLAY_VIEW', view }
}

export function setAuthOverlayExit(exit) {
    return { type: 'SET_AUTH_OVERLAY_EXIT', exit }
}

export function setActiveMember() {
    return { type: 'SET_ACTIVE_MEMBER' }
}

export function setStatusFilter(status) {
    return { type: 'SET_STATUS_FILTER', status }
}

export function setIsSaving(isSaving) {
    return { type: 'SET_IS_SAVING', isSaving }
}

export function setIsSaved(isSaved) {
    return { type: 'SET_IS_SAVED', isSaved }
}

export function setIsMockData(isMockData) {
    return { type: "SET_IS_MOCK_DATA", isMockData }
}


export function setShowExitWarning(show) {
    return { type: 'SET_SHOW_EXIT_WARNING', show }
}

export function setMenuObjectImportLocation(id) {
    return { type: 'SET_MENU_OBJECT_IMPORT_LOCATION', id }
}

export function setMenuObjectImportDesign(id) {
    return { type: 'SET_MENU_OBJECT_IMPORT_DESIGN', id }
}

export function setMenuObjectImportName(name) {
    return { type: 'SET_MENU_OBJECT_IMPORT_NAME', name }
}

export function setOnlineMenuImport(menu) {
    return { type: 'SET_ONLINE_MENU_IMPORT', menu }
}

export function setIsDesignLoading(loading) {
    return { type: 'SET_IS_DESIGN_LOADING', loading }
}

export function setWebsiteToken(websiteToken) {
    return { type: 'SET_WEBSITE_TOKEN', websiteToken }
}

export function setShareLink(shareLink) {
    return { type: 'SET_SHARE_LINK', shareLink }
}

export function setInSync(inSync) {
    return { type: 'SET_IN_SYNC', inSync}
}

export function setIsSyncing(isSyncing) {
    return { type: 'SET_IS_SYNCING', isSyncing}
}

export function setIsSyncingQR(isSyncingQR) {
    return { type: 'SET_IS_SYNCING_QR', isSyncingQR}
}

export function setMobileVersion(isMobileVersion) {
    return { type: 'SET_MOBILE_VERSION', isMobileVersion}
}

export function setIniFrame(iniFrame) {
    return { type: 'SET_IN_IFRAME', iniFrame}
}

export function setReplaceFrameMode(isReplaceFrameMode) {
    return { type: 'SET_REPLACE_FRAME_MODE', isReplaceFrameMode}
}

export function setSelectionType(selectionType) {
    return { type: 'SET_SELECTION_TYPE', selectionType}
}

export function setView(view) {
    return { type: 'SET_VIEW', view}
}

export function updatePrintAdvisor(printAdvisor) {
    return {
        type: 'UPDATE_PRINT_ADVISOR',
        printAdvisor,
    }
}
export function setIsAppLoading(isAppLoading, appLoadingInfo) {
    return {
        type: 'SET_IS_APP_LOADING',
        isAppLoading,
        appLoadingInfo
    }
}

export function setColorPickerType(colorPickerType) {
    return {
        type: 'SET_COLOR_PICKER_TYPE',
        colorPickerType
    }
}

export function setPrevAsideView(prevAsideView) {
    return  {
        type: 'SET_PREV_ASIDE_VIEW',
        prevAsideView
    }
}

export function setIsQRDesignMode(isQRDesignMode) {
    return {
        type: 'SET_IS_QR_DESIGN_MODE',
        isQRDesignMode
    }
}

export function setIsAddQRMode(isAddQRMode) {
    return {
        type: 'SET_IS_ADD_QR_MODE',
        isAddQRMode
    }
}

export function setPrintPaperType(printPaperType) {
    return {
        type: 'SET_PRINT_PAPER_TYPE',
        printPaperType
    }
}

export function setPrintPagination(printPagination) {
    return {
        type: 'SET_PRINT_PAGINATION',
        printPagination
    }
}

export function setPrintQuantity(printQuantity) {
    return {
        type: 'SET_PRINT_QUANTITY',
        printQuantity
    }
}

export function setPosData(posFeature, toastEmail, isClover, isSquare, isTreez, isPopmenu) {
    return {
        type: 'SET_POS_DATA',
        posFeature,
        toastEmail,
        isClover,
        isSquare,
        isTreez,
        isPopmenu
    }
}

export function setMenuGroups(menuGroups) {
    return {
        type: "SET_MENU_GROUPS",
        menuGroups
    }
}

export function setMenuGroupsSource(menuGroupsSource) {
    return {
        type: "SET_MENU_GROUPS_SOURCE",
        menuGroupsSource
    }
}

export function setMenuGroupsSourceInProgress(menuGroupsSourceInProgress) {
    return {
        type: "SET_MENU_GROUPS_SOURCE_IN_PROGRESS",
        menuGroupsSourceInProgress
    }
}

export function setApplyToMoInProgress(applyToMoInProgress) {
    return {
        type: "APPLY_TO_MO_IN_PROGRESS",
        applyToMoInProgress
    }
}

export function setSquareLoading(squareLoading) {
    return {
        type: 'SET_SQUARE_LOADING',
        squareLoading,
    }
}

export function setSquareSelect(squareSelect) {
    return {
        type: 'SET_SQUARE_SELECT',
        squareSelect,
    }
}

export function setMenuActiveIcons(menuActiveIcons) {
    return {
        type: 'SET_MENU_ACTIVE_ICONS',
        menuActiveIcons,
    }
}

export function setPosAutoSyncEnabled(posAutoSyncEnabled) {
    return {
        type: 'SET_POS_AUTO_SYNC_ENABLED',
        posAutoSyncEnabled,
    }
}

export function setDsaAutoSyncEnabled(dsaAutoSyncEnabled) {
    return {
        type: 'SET_DSA_AUTO_SYNC_ENABLED',
        dsaAutoSyncEnabled,
    }
}

export function setLinksAutoSyncEnabled(linksAutoSyncEnabled) {
    return {
        type: 'SET_LINKS_AUTO_SYNC_ENABLED',
        linksAutoSyncEnabled,
    }
}

export function setPosSyncPendingCount(posSyncPendingCount) {
    return {
        type: 'SET_POS_SYNC_PENDING_COUNT',
        posSyncPendingCount,
    }
}

export function setHasPosData(hasPosData) {
    return {
        type: "SET_HAS_POS_DATA",
        hasPosData,
    }
}

export function setIsDSADesign(isDSADesign) {
    return {
        type: 'IS_DSA_DESIGN',
        isDSADesign,
    }
}

export function setMainNotificationMessage(mainNotificationMessage) {
    return {
        type: 'MAIN_NOTIFICATION_MESSAGE',
        mainNotificationMessage,
    }
}

export function setIsMobileAside(isMobileAside) {
    return {
        type: 'IS_MOBILE_ASIDE',
        isMobileAside,
    }
}

export function setIsViewAllPages(isViewAllPages) {
    return {
        type: 'IS_VIEW_ALL_PAGES',
        isViewAllPages,
    }
}

export function setIsMobileBottomNav(isMobileBottomNav) {
    return {
        type: 'IS_MOBILE_BOTTOM_NAV',
        isMobileBottomNav,
    }
}

export function setIsAltTextModal(isAltTextModal) {
    return {
        type: 'IS_ALT_TEXT_MODAL',
        isAltTextModal,
    }
}

export function setSelectedUploadedImage(selectedUploadedImage) {
    return {
        type: 'SELECTED_UPLOADED_IMAGE',
        selectedUploadedImage,
    }
}

export function setSelectedUploadedIcon(selectedUploadedIcon) {
    return {
        type: 'SELECTED_UPLOADED_ICON',
        selectedUploadedIcon,
    }
}

export function setIsJustUploaded(isJustUploaded) {
    return {
        type: 'IS_JUST_UPLOADED',
        isJustUploaded,
    }
}

export function setLastSelectedHighlightId(lastSelectedHighlightId) {
    return {
        type: 'LAST_SELECTED_HIGHLIGHT_ID',
        lastSelectedHighlightId
    }
}

export function setFavoriteAssets(favoriteAssets) {
    return {
        type: 'SET_FAVORITE_ASSETS',
        favoriteAssets,
    }
}
